import React from 'react'
import ReactDOMServer from 'react-dom/server'

const privacyLink = () => {
  return ReactDOMServer.renderToString(
    <a href="/privacy" className="link link--embed" target="_blank">
      { I18n.t('registration.privacy_link') }
    </a>
  )
}

const eulaLink = () => {
  return ReactDOMServer.renderToString(
    <a href="/eula" className="link link--embed" target="_blank">
      { I18n.t('registration.eula_link') }
    </a>
  )
}

export default () => {
  return {
    __html: I18n.t('parent_students.new.you_agree_with', {
      privacy_link: privacyLink(),
      eula_link: eulaLink()
    })
  }
}
